import Cart from './cart/Cart.react';
import PosSearch from './search/PosSearch.react';
import PosTypeSearch from './search/PosTypeSearch.react';
import ViewHistory from '../profile/view/ViewHistory.react';
import Transaction from '../profile/view/Transaction.react';

class PosMain extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            viewTransactionDetails : false
        };
    }

    render() {
        var self                 = this;
        var page                 = this.props.page;
        var guest                = this.props.guest;
        var cart                 = this.props.cart;
        var searchResults        = this.props.searchResults;
        var productList          = this.props.productList;
        var appliedLoyaltyPoints = this.props.appliedLoyaltyPoints;
        var appliedDiscounts     = this.props.appliedDiscounts;
        var allotment            = this.props.allotment;
        var query                = this.props.query;
        var remotePayInfo = this.props.remotePayInfo;

        var content = '';
        switch (page)
        {
            case 'cart':
                content = <Cart
                            guest={guest}
                            cart={cart}
                            appliedLoyaltyPoints={appliedLoyaltyPoints}
                            appliedDiscounts={appliedDiscounts}
                            allotment={allotment} 
                            remotePayInfo={remotePayInfo} />;
                break;

            case 'productSearch':
                content = <PosSearch
                            guest={guest}
                            cart={cart}
                            query={query}
                            searchResults={searchResults}
                            productList={productList} />;
                break;

            case 'strainSearch':
                content = <PosTypeSearch
                            guest={guest}
                            cart={cart}
                            query={query || ''}
                            listKey={'Strain'}
                            page={'strainSearch'}
                            itemList={this.props.strainList}
                            productList={productList}
                            onSearch={this.props.onSearch}
                            />;
                break;
            case 'categorySearch':
                content = <PosTypeSearch
                            guest={guest}
                            cart={cart}
                            query={query || ''}
                            page={'categorySearch'}
                            listKey={'ProductCategory'}
                            itemList={this.props.categoryList}
                            productList={productList} 
                            onSearch={this.props.onSearch}
                            />;
                break;

            case 'product':
            case 'transaction':
            case 'history':
                content = <ViewHistory
                            guest={guest}
                            page={page}
                            className='view-history__pos'
                            viewTransactionDetails={item => { this.setState({ viewTransactionDetails : item }); }} />
                break;

            
                break;

            // case 'by-category':
            //     content = <BrowseByCategory
            //                 guest={guest}
            //                 cart={cart} />;
            //     break;
        }

        return ([
            <div
                id='pos-main'
                className='pos-main'>

                    {content}
            </div>,
            ( this.state.viewTransactionDetails &&
                <Transaction
                    guest={guest}
                    selected={this.state.viewTransactionDetails}
                    onClose={() => { this.setState({ viewTransactionDetails : false }); }} />
            )
        ]);
    }
}

export default PosMain;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/PosMain.react.jsx